import { render, staticRenderFns } from "./OrderDesigns.vue?vue&type=template&id=aeadf348&"
import script from "./OrderDesigns.vue?vue&type=script&lang=js&"
export * from "./OrderDesigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports